import { daysUntilExpiry, RENEWAL_WARN_DAYS } from '@iws/backoffice-api'
import { X } from 'lucide-react'

import { useState } from 'react'

import { useSyncState } from '@/contexts/SessionContext'

export const RenewalAlertBar = () => {
  const { expirationDate, status, error } = useSyncState()
  const [hidden, setHidden] = useState(false)
  const days = daysUntilExpiry(expirationDate)
  const suspended = status === 'suspended'

  if (hidden || (!suspended && (days === null || days > RENEWAL_WARN_DAYS))) return null
  const plural = (n: number) => `${n} day${n === 1 ? '' : 's'}`
  const text = suspended
    ? error
    : days! < 0
      ? `The subscription ended ${plural(Math.abs(days!))} ago. Ask the owner to renew it in the admin dashboard.`
      : days === 0
        ? 'The subscription ends today. Ask the owner to renew it in the admin dashboard.'
        : `The subscription ends in ${plural(days!)}. Ask the owner to renew it in the admin dashboard.`
  const urgent = suspended || days! < 0

  return (
    <div role="status" className={`flex items-center gap-3 px-4 py-2 text-sm ${urgent ? 'bg-error-lighter text-error-dark' : 'bg-warning-lighter text-warning-dark'}`}>
      <span className="min-w-0 flex-1">{text}</span>
      <button type="button" aria-label="Hide" onClick={() => setHidden(true)} className="shrink-0 rounded p-1 hover:bg-fill-hover">
        <X className="size-4" />
      </button>
    </div>
  )
}
